
import { Component, Prop, Ref, Vue } from "vue-property-decorator"
import LightDarkSwitch from "@/components/Account/LightDarkSwitch.vue"
import NewInterfaceSwitch from "@/components/Account/NewInterfaceSwitch.vue"
import { Action, Getter, Mutation, State } from "vuex-class"
import { CurrentUser } from "@/types/user"
import { LoginResultTenant } from "@/types"
import api from "@/services/api"
import SetStatusModal from "@/components/SetStatusModal.vue"
import tenantApi from "@/services/api_Tenant"
import UserSettingsModal from "@/components/UserSettingsModal.vue"
import NewLightDarkSwitch from "@/components/Account/NewLightDarkSwitch.vue"
import { BaseState } from "@/store"
import UpdatesViewer from "@/components/Updates/UpdatesViewer.vue"
import { TenantFeatures } from "@/types/tenantFeatures"
import TenantInfoDisplay from "@/components/Info/TenantInfoDisplay.vue"
import DiagnosticInformation from "@/components/Info/DiagnosticInformation.vue"

@Component({
	components: {
		NewLightDarkSwitch,
		"light-dark": LightDarkSwitch,
		"new-interface-switch": NewInterfaceSwitch,
		"set-status-modal": SetStatusModal,
		"user-settings-modal": UserSettingsModal,
		"updates-viewer": UpdatesViewer,
		"info-display": TenantInfoDisplay,
		"diagnostic-display": DiagnosticInformation
	}
})
export default class UserMenu extends Vue {
	// TODO remove
	@Ref() setStatusModal!: SetStatusModal
	@Ref() userSettingsModal!: UserSettingsModal

	@Getter("getUseV2") usingV2!: boolean

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	@Prop({ type: String, required: true })
	pictureUrl!: string;

	@Prop({ type: Boolean, default: false })
	showNewInterfaceSwitch!: boolean;

	@State((state: BaseState) => state.me) public me!: CurrentUser;
	@Getter("hasSubscription") hasSubscription!: boolean;

	@Action("selectTenant")
	public loginSelectTenant!: (tenant: LoginResultTenant) => Promise<void>

	@Action("logOut")
	public logOut!: () => void;

	@Mutation
	private setManualLogout!: (manualLogout: boolean) => void

	infoShown: boolean = false
	diagnosticsShown: boolean = false
	pictureError: boolean = false

	private showSetStatus () {
		this.setStatusModal.open()
	}

	private showUserSettings () {
		this.userSettingsModal.open()
	}

	private get otherTenants (): LoginResultTenant[] {
		if (!this.me || !this.me.loginTenants) {
			return []
		}

		return this.me.loginTenants.filter(t => !t.disabled && t.id !== this.me.tenantId)
	}

	private get userProfilePictureUrl (): string {
		if (this.pictureError) return "images/blank_user.png"
		return this.pictureUrl
	}

	public async logout () {
		this.setManualLogout(true)

		await api.logout()
		this.logOut()
	}

	private requestUpdatesModal () {
		this.$emit("showUpdates", true)
	}

	get infoEnabled (): boolean {
		return this.me && !!this.me.hasTenantInfo && this.getIsFeatureEnabled(TenantFeatures.TenantInformation)
	}

	get diagnosticsEnabled (): boolean {
		return this.getIsFeatureEnabled(TenantFeatures.DiagnosticsInfo)
	}

	public imageUrlError (args: any) {
		this.pictureError = true
	}
}
